import React, { useEffect, useState } from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { TablaDetalleMovsEnvio } from './TablaDetalleMovsEnvio';
import servicioObjetos from '../../servicio/ServicioObjetos';

const MENSAJE_FUERA_LINEAMIENTOS = "Movimiento enviado en el límite de tiempo y fuera de nuestros lineamientos ¿Deseas continuar?";
export const AlertaFechaMovimientos = (props) => {
    const { funcionGuardarMovimientos, datos, setDatos, funcionCerrar } = props;
    const [mostrarModal, setMostrarModal] = useState(false);
    const [datosMostrar, setDatosMostrar] = useState([]);

    useEffect(() => {
        setMostrarModal(!servicioObjetos.esObjetoVacio(datos));
        let movimientosResumen = [];
        for (let i = 0; i < datos.length; i++) {
            let elemento = datos[i];
            movimientosResumen = movimientosResumen.concat(elemento.datosMovimientos);
        }
        setDatosMostrar(movimientosResumen);
    }, [datos]);

    const pie = () => {
        return (
            <div >
                <Button label="Eliminar movimientos fuera de tiempo" icon="pi pi-md-delete" onClick={eliminarMovimientosFechaFueraRango} className="p-button-danger" />
                <Button label="Acepto enviar todos" icon="pi pi-check" onClick={aceptar} disabled={servicioObjetos.esObjetoVacio(datosMostrar)} />
                <Button label="Cancelar" icon="pi pi-times" onClick={cancelar} className="p-button-secondary" />
            </div>
        );
    }

    const eliminarMovimientosFechaFueraRango = () => {
        const cloneDatos = [...datos];
        for (let i = 0; i < cloneDatos.length; i++) {
            let elemento = cloneDatos[i];
            for (var j = elemento.datosMovimientos.length - 1; j >= 0; j--) {
                let movimiento = elemento.datosMovimientos[j];
                if (!servicioObjetos.esObjetoVacio(movimiento) && movimiento.observacionEnTiempoFechaMovimiento === MENSAJE_FUERA_LINEAMIENTOS) {
                    servicioObjetos.eliminarObjetoMapa(elemento.datosMovimientos, movimiento);
                }
            }
        }
        setDatos(cloneDatos);
    }



    const aceptar = () => {
        cerrarModal();
        funcionGuardarMovimientos();
    }

    const cancelar = () => {
        cerrarModal();
        funcionCerrar();
    }

    const cerrarModal = () => {
        setMostrarModal(false);
    }
    return (
        <div>

            <Dialog appendTo={document.body} header={"Confirmación de envío de movimientos: " + datosMostrar.length + " movimientos a enviar"} visible={mostrarModal}
                style={{ width: '90%' }} onHide={() => cerrarModal()} blockScroll
                footer={pie()}>
                <h4>Estimado usuario este es el desgloce de los movimientos que usted va a envíar al idse:</h4>
                <TablaDetalleMovsEnvio datos={datosMostrar} />
                <h5>Si los datos son correctos entonces click en "Acepto" de lo contrario click en "Cancelar"</h5>
            </Dialog>
        </div>
    );
}